// @ts-check
import React from 'react';

import { formControlLabelClasses } from '@liquidweb-dev/undercurrent/FormControlLabel';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import RadioTile from '@liquidweb-dev/undercurrent/RadioTile';
import { currency } from 'utility/format';
import CheckIcon from '@liquidweb-dev/undercurrent/icons/lucide/Check';

/**
 * @param {string} cycle
 */
const cycleDisplay = (cycle) => {
	switch (cycle) {
		case 'month':
			return 'mo';
		default:
			return cycle;
	}
};

/**
 * @typedef BackupSettingsQuotaSelectOptionProps
 * @property {number} [basePrice]
 * @property {number} [currentQuota]
 * @property {boolean} [disabled]
 * @property {import('@liquidweb-dev/club-sauce/public/product/index.raw').LWApiPublicProductFlatDetailsResultFlatOptionValueRawI} option
 * @property {number} regionId
 * @property {number | string} value
 */

/**
 * @param {BackupSettingsQuotaSelectOptionProps & import('@liquidweb-dev/undercurrent/RadioTile').RadioTileProps} props
 */
const BackupSettingsQuotaSelectOption = ({
	basePrice = 0,
	currentQuota,
	disabled = false,
	option,
	regionId,
	value,
	...rest
}) => {
	/** @param {import('@liquidweb-dev/club-sauce/public/product/index.raw').LWApiPublicProductFlatDetailsResultFlatOptionValueRawI} item */
	const getQuotaPrice = (item) => {
		const itemPrice = item?.region_id_prices?.[regionId] ?? 0;
		return `${currency(basePrice + Number(itemPrice))}/${cycleDisplay(item.price_time_unit)}`;
	};

	return (
		<RadioTile
			value={option.ptov_id}
			checked={value === option.ptov_id}
			disabled={disabled}
			sx={{
				width: 1,
				[`& .${formControlLabelClasses.label}`]: {
					width: 1,
				},
			}}
			{...rest}
		>
			<Stack spacing={100}>
				<Stack direction="row" spacing={100} alignItems="center">
					{currentQuota === Number(option.value) && (
						<CheckIcon
							sx={({ size }) => ({
								width: size.xS,
								height: size.xS,
							})}
						/>
					)}
					<Typography variant="title-xs" fontWeight={500}>
						{option.description}
					</Typography>
				</Stack>
				<Typography
					variant="body-sm"
					sx={{
						color: ({ vars }) => vars.palette.uc.text.weak,
					}}
				>
					{getQuotaPrice(option)}
				</Typography>
			</Stack>
		</RadioTile>
	);
};

export default BackupSettingsQuotaSelectOption;
